import React, {
    Component
} from 'react';
import Select from 'react-select'
import CorpusSelector from '../Corpora'
import * as Animated from 'react-select/lib/animated';
import MenuItemGroup from './MenuGroup/MenuGroup'

import './Menu.css'



class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            corpus: [],
            skipP: true,
            caseInsensitive: false,
            // regex: true,
            minFreq: 100,
            ordflokkur: [],
            searchMethod: 'word',
            searchWord: ''
        }
    }

	componentDidMount() {
		window.setSelect = (val) => {
			let corpus = this.state.corpus;
			corpus.push(val);

			this.setState({
				corpus: corpus
			})
		}
	}

    render() {
        return (
            <div>
                <CorpusSelector
                    changeCorporaSelection={this.handleChangeSelection('corpus')}
                    selectedCorpora={this.state.corpus}
					onPieSelect={(e) => {
						let selectedCorpus = this.state.corpus;

						let inArray = false;

						selectedCorpus.forEach((item, i) => {
							if (item.label == e.name && item.value == e.titill) {
								inArray = true;
							}
						});

						if (!inArray) {
							selectedCorpus.push({
								label: e.name,
								value: e.titill
							});

							this.setState({
								corpus: selectedCorpus
							});
						}
					}}
                />
				<hr/>
                <Options
                    options={this.state}
                    onChange={this.handleChangeOptions}
                    changeOrdflokkur={this.handleChangeSelection('ordflokkur')}
                >
					<hr/>
					{/*
                    <MenuItemGroup>
                        {this.menuListItems()}
                    </MenuItemGroup>
					*/}
                    <MenuItemGroup>

						<div className='col menu-input'>

							<div className="form-group">
								<label>
									Leita eftir orðmynd/uppflettimynd/greiningarstreng
								</label>
								<input type='text' placeholder='leitarorð' className="form-control" value={this.state.searchWord || ""} onChange={this.handleChangeSearchTerm('searchWord')}/>
							</div>

							<div className="mb-3">
								<div className="form-check form-check-inline">
									<input className="form-check-input" type="radio" name="searchMethod" id="searchMethod1" value="word" onChange={this.handleChangeSearchTerm('searchMethod')} checked={this.state.searchMethod == 'word'} />
									<label className="form-check-label" htmlFor="searchMethod1">Leita eftir orðmynd</label>
								</div>
								<div className="form-check form-check-inline">
									<input className="form-check-input" type="radio" name="searchMethod" id="searchMethod2" value="lemma" onChange={this.handleChangeSearchTerm('searchMethod')} checked={this.state.searchMethod == 'lemma'} />
									<label className="form-check-label" htmlFor="searchMethod2">Leita eftir uppflettimynd</label>
								</div>
								<div className="form-check form-check-inline">
									<input className="form-check-input" type="radio" name="searchMethod" id="searchMethod3" value="mark" onChange={this.handleChangeSearchTerm('searchMethod')} checked={this.state.searchMethod == 'mark'} />
									<label className="form-check-label" htmlFor="searchMethod3">Leita eftir greiningarstreng</label>
								</div>
							</div>

							<div>
								<button className="btn btn-main menu-button mr-5" onClick={this.searchButtonClick}>Leita</button>
								<div className="float-right">
		                        	{this.menuListItems(true)}
								</div>
		                    </div>

						</div>
					</MenuItemGroup>
                    <MenuItemGroup>
						<div className="d-none">
							{this.makeMenuInput('word', <span>Leita eftir orðmynd: </span>)}
	                        {this.makeMenuInput('lemma', <span>Leita eftir uppflettimynd: </span>)}
	                        {this.makeMenuInput('mark', <span>Leita eftir greiningarstreng (<a download href={process.env.PUBLIC_URL + '/markaskra.pdf'}>sjá markaskrá</a>): </span>)}
						</div>
                    </MenuItemGroup>
                </Options>
            </div>
        )
    }

    menuButtons = [{
            text: "Orðmyndir eftir tíðni",
            id: "topWords",
            url: "/lists/ordmynd"
        },
        {
            text: "Uppflettimyndir eftir tíðni",
            id: "topLemma",
            url: "/lists/lemma"
        },
        {
            text: "Mörk eftir tíðni",
            id: "topTag",
            url: "/lists/mark"
        }
    ];

    menuListItems = (onlyButtonTag) => this.menuButtons.map((opt) => {
        return (
            onlyButtonTag ? <button key={opt.id} className='btn btn-main menu-button mr-2' onClick={() => this.props.onSelect(opt.url, this.state)}>{opt.text}</button> :
			<div className='col menu-button-li' key={opt.id}>
              <button className='btn menu-button' onClick={() => this.props.onSelect(opt.url, this.state)}>{opt.text}</button>
            </div>
        )
    });

    handleChangeOptions = (opt, update) => {
        const newOptions = {...this.state};
        update(newOptions, opt)
        this.setState(newOptions)
    }

    handleChangeSelection = (type) => (e) => {
        this.setState({
            [type]: e
        })
    }

    handleChangeSearchTerm = (type) => (e) => {
        this.setState({
            [type]: e.target.value
        })
    }

    handleSimpleSearch = (e, type, terms) => {
        e.preventDefault()
        fetch(this.hostname + '/search?' + type + '=' + terms[type])
            .then(res => res.json())
            .then(data => this.setState({
                listData: data
            }))
    }

    createSearchHandler = (type) => (e) => {
        e.preventDefault();
        const url = '/search?' + type + '=' + this.state[type] +
            // (this.state.regex ? '&regex' : '') +
            (this.state.corpus.length ? `&corpus=${this.state.corpus.map(c => c.value).join(',')}` : '') +
            (this.state.minFreq > 0 ? `&minFreq=${this.state.minFreq}` : '');
        this.props.searchHandler(url);
    }

	searchButtonClick = (e) => {
        e.preventDefault();

		if (this.state.searchWord && this.state.searchWord != '') {
	        const url = '/search?' + this.state.searchMethod + '=' + this.state.searchWord +
	            // (this.state.regex ? '&regex' : '') +
	            (this.state.corpus.length ? `&corpus=${this.state.corpus.map(c => c.value).join(',')}` : '') +
	            (this.state.minFreq > 0 ? `&minFreq=${this.state.minFreq}` : '');
	        this.props.searchHandler(url);
		}
    }

    makeMenuInput = (type, prompt) => (
        <div className='col menu-input'>
            <SearchInput
                searchPrompt={prompt}
                type={type}
                value={this.state[type]}
                changeSearchTerm={this.handleChangeSearchTerm(type)}
                searchHandler={this.createSearchHandler(type)}
                />
        </div>
    )

}

const SearchInput = (props) => {
    return (
        <React.Fragment>
			<div className="form-group">
	            <label>
	                {props.searchPrompt}
				</label>
                <input type='text' placeholder='leitarorð' className="form-control" value={props.value || ""} onChange={props.changeSearchTerm}/>
	        </div>
			<button className="btn" onClick={(e) => props.searchHandler(e, props.type)}>Leita</button>
		</React.Fragment>
    )
}

class Options extends Component {

    menuItemNames = {
        "skipP": "Sleppa greinarmerkjum: ",
        "caseInsensitive": "Óstafnæm leit (mjög hæg): ",
        "selectedPos": "Valdir orðflokkar: ",
        "ordflokkur": "Valdir orðflokkar:",
        "minFreq": "Lágmarksfjöldi niðurstaðna: ",
        "regex": "Styðja reglulegar segðir (regex): ",
        'nafnháttarmerki': 'Nafnháttarmerki',
        'lýsingarorð': 'Lýsingarorð',
        'ógreint': 'Ógreint',
        'sagnorð': 'Sagnorð',
        'töluorð': 'Töluorð',
        'atviksorð': 'Atviksorð',
        'erlentorð': 'Erlent orð',
        'samtenging': 'Samtenging',
        'fornafn': 'Fornafn',
        'veffang': 'Veffang',
        'nafnorð': 'Nafnorð',
        'greinarmerki': 'Greinarmerki',
        'greinir': 'Greinir',
        'forsetning': 'Forsetning',
        'upphrópun': 'Upphrópun'
    }

    ordflokkar = [
        'nafnháttarmerki',
        'lýsingarorð',
        'ógreint',
        'sagnorð',
        'töluorð',
        'atviksorð',
        'erlentorð',
        'samtenging',
        'fornafn',
        'veffang',
        'nafnorð',
        'greinarmerki',
        'greinir',
        'forsetning',
        'upphrópun'
    ]

    ordflokkarOptions = []

    toggleCheckbox = (options, opt) => {
        options[opt] = !options[opt]
    }

    makeCheckboxLi = (opt) => {
        return (
            <div className='col menu-checkbox form-check' key={opt}>
				<input
					className="form-check-input"
					type='checkbox'
					checked={this.props.options[opt]}
					onChange={() => this.props.onChange(opt, this.toggleCheckbox)}/>
				<label className="form-check-label">{this.menuItemNames[opt] || opt}</label>
            </div>
        )
    }

    makeSelectLi = (opt, data) => {
        const selectData = data.map(item => {
            return {
                value: item,
                label: this.menuItemNames[item] || item
            }
        });
        return (
            <div className='col menu-select' key={opt}>
                {this.menuItemNames[opt] || opt}
                <div style={{display: 'inline-block', width: '100%'}}>
                    <Select
                        components={Animated}
                        closeMenuOnSelect={false}
                        options={selectData}
                        isMulti
                        onChange={this.props.changeOrdflokkur}
                        placeholder='Veldu einn eða fleiri orðflokka úr fellivalmyndinni...'
                    />
                </div>
            </div>
        )
    }

    makeNumberLi = (opt) => {
        return (
            <div className='col col-3' key={opt}>
				<div className="form-group">
	                <label>{this.menuItemNames[opt] || opt}</label>
                    <input
						className="form-control"
                        type='number'
                        value={this.props.options[opt]}
                        onChange={(e) => (
                            this.props.onChange(opt, (options, opt) => (
                                options[opt] = parseInt(e.target.value, 10)))
                            )
                        }/>
				</div>
            </div>
        )
    }

    render() {
        return (
            <div>
                <MenuItemGroup>
					{this.makeSelectLi('ordflokkur', this.ordflokkar)}
					<div>
	                    {this.makeCheckboxLi('skipP')}
	                    {this.makeCheckboxLi('caseInsensitive')}
					</div>
                    {/*this.makeCheckboxLi('regex')*/}
                    {this.makeNumberLi('minFreq')}
                </MenuItemGroup>
                {this.props.children}
            </div>
        )
    }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/Search/Menu/Menu.js